import { useEffect } from "react";
import "./Map.scss";
import LoadingSpinner from "../LoadingSpinner/LoadingSpinner";
import { LoadScript, GoogleMap, Marker } from "@react-google-maps/api";

export default function Map(props) {
  const { REACT_APP_SECRET_GOOGLE_API_KEY } = process.env;
  const containerStyle = {
    width: "100%",
    height: "80vh",
  };

  useEffect(() => {
    props.setLocation({
      lat: 49.2786062,
      lng: -123.0999113,
    });
  }, []);
  if (!props.currentLocation.lat) {
    return <LoadingSpinner />;
  }
  return (
    <div className="map">
      <LoadScript googleMapsApiKey={REACT_APP_SECRET_GOOGLE_API_KEY}>
        <GoogleMap
          mapContainerStyle={containerStyle}
          center={props.currentLocation}
          zoom={17}
          options={{
            mapTypeId: "satellite",
            fullscreenControl: false,
            disableDoubleClickZoom: true,
            disableDefaultUI: true,
          }}
        >
          <Marker animation="1" position={props.currentLocation} />
        </GoogleMap>
      </LoadScript>
    </div>
  );
}
